import { Record } from 'immutable';

import { accountsTypes } from 'companion-app-components/flux/accounts';
import { resourceStoreTypes } from 'companion-app-components/flux/core';

export type AccountsStoreProps = resourceStoreTypes.QcsSyncResourceStoreProps<accountsTypes.AccountProps> & {
  isInvestmentAccountsLoading: boolean;
};

export type AppAccountsState = resourceStoreTypes.QcsSyncResourceStore<accountsTypes.AccountProps, AccountsStoreProps>;

export const AccountsStoreRecord = Record<AccountsStoreProps>({
  ...(resourceStoreTypes.mkQcsSyncResourceStore({ resourceName: 'ACCOUNTS' }).toObject() as AccountsStoreProps),
  isInvestmentAccountsLoading: false,
});
